* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: 100%;
  padding-top: calc(7 * var(--spacer));
}

.log-entries-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  &--header {
    padding: calc(var(--spacer) / 2) calc(2 * var(--spacer));
    color: var(--main-titles-inputs-600);
  }

  &--content {
    flex-grow: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding-bottom: calc(7 * var(--spacer));
    padding-left: calc(2 * var(--spacer));
    padding-right: calc(2 * var(--spacer));
  }

  &--loader {
    display: flex;
    align-items: center;
    height: 100%;

    gz-progress-spinner {
      padding: calc(2 * var(--spacer)) 0;
      display: flex;
      justify-content: center;
    }
  }

  &--footer {
    width: 100%;
    align-self: flex-end;
    padding-top: calc(5 * var(--spacer));
    padding-bottom: calc(2 * var(--spacer));
    padding-left: calc(2 * var(--spacer));

    gz-button:first-of-type {
      margin-right: var(--spacer);
    }
  }
}

.log-entry {
  padding-top: var(--spacer);
  color: var(--grey-layout-300-50-opacity);
  &--message {
    padding: var(--spacer) 0;
    color: var(--chart-302-icon-buttons-titles);
  }
  border-bottom: 1px solid var(--chart-101-pressed-dividers);

  &--row {
    display: flex;
    align-items: center;
    margin-bottom: var(--spacer);
    column-gap: calc(2 * var(--spacer));
    &__label,
    &__value {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-flex;
    }

    &__label {
      width: 40%;
      color: var(--chart-300-icon-buttons);
    }
    &__value {
      width: 60%;
      color: var(--body-text-arrows-400);
      display: flex;
      align-items: center;

      gz-severity-icon {
        margin-right: calc(var(--spacer) / 2);
      }
    }
    gz-text {
      display: inline;
    }
  }
}
